import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    USER_LANGUAGE_POST_FAILURE: "USER_LANGUAGE_POST_FAILURE",
    USER_LANGUAGE_POST_REQUEST: "USER_LANGUAGE_POST_REQUEST",
    USER_LANGUAGE_POST_SUCCESS: "USER_LANGUAGE_POST_SUCCESS",
};

export const actionCreators = {
    /**
     * Audit Download API GET
     */
    postRequest: (detail) => ({
        type: actionTypes.USER_LANGUAGE_POST_REQUEST,
        payload: { detail },
        [WAIT_FOR_ACTION]: actionTypes.USER_LANGUAGE_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.USER_LANGUAGE_POST_FAILURE,
    }),
    postSuccess: () => ({
        type: actionTypes.USER_LANGUAGE_POST_SUCCESS,
        saveReduxState: true,
    }),
    postFailure: (error) => ({
        type: actionTypes.USER_LANGUAGE_POST_FAILURE,
        error,
    }),
};

export default {
    create: actionCreators,
    type: actionTypes,
};
